import type { MessageHandlerResult } from "@/services/abstract/poc/MessagingService";
import type { HeliaNode } from "@/types/poc/helia";
import type { LibP2pWithServices } from "@/types/poc/libp2p";
import type { MessageHandler, MessagePayload } from "@/types/poc/message";
import { createLogger, type Logger } from "@/utils/logger";

const log: Logger = createLogger({ namespace: 'six3ro:p2p:handlers:file-replication-started' });

type FileReplicationStartedVariant = Extract<MessageHandlerResult, { type: 'file-replication-started' }>;

export const createFileReplicationStartedHandler = (): MessageHandler<FileReplicationStartedVariant> => ({
  canHandle: (_topic: string, message: MessagePayload): boolean =>
    message.type === 'file-replication-started',

  process: (
    message: MessagePayload,
    _libp2p: LibP2pWithServices,
    _heliaNode: HeliaNode | null
  ): FileReplicationStartedVariant => {
    if (message.type !== 'file-replication-started') {
      throw new Error(`Invalid message type: expected 'file-replication-started', got '${message.type}'`);
    }

    const { cid, sixId, totalBytes, targetPeerId, sender, timestamp } = message;
    log.info('Received file-replication-started for CID:', cid, 'sixId:', sixId, 'from', sender);

    return {
      type: 'file-replication-started',
      data: {
        cid,
        sixId,
        totalBytes,
        targetPeerId,
        sender,
        messageTimestamp: timestamp,
      },
    };
  }
});
